<cv-loader [hidden]="!showLoader"></cv-loader>

<!-- Header -->
<button *ngIf="config.isCxOne" type="button" class="icon-btn fill-iconDefault modal-close" style="padding-top: 3px;" [disabled]="isSaving" (click)="onCancelClicked()">
    <svg class="icon-12">
        <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
    </svg>
</button>
<button *ngIf="!config.isCxOne" type="button" class="icon-btn fill-cxone fill-hover-whaleTail modal-close" style="padding-top: 3px;" [disabled]="isSaving" (click)="onCancelClicked()">
    <svg class="icon-16">
        <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
    </svg>
</button>
<div class="modal-header">
    <span cvLocalizedText langSection="Dashboard_Access" langKey="Share_Dashboard">Share Dashboard</span>
</div>

<!-- Body -->
<div class="modal-body" [ngClass]="selection === custom ? 'share-custom-body' : 'share-body'">

    <!-- Slide Toggle -->
    <div class="bodyRow d-flex">
        <cxone-slide-toggle ngbAutoFocus styleClass="medium-toggle" [(ngModel)]="shareDashboard" (change)="checkSelection()"></cxone-slide-toggle>
        <div class="ml-2" cvLocalizedText langSection="Dashboard_Access" langKey="Share_Dashboard">Share Dashboard</div>
    </div>

    <!-- Radio Buttons -->
    <div class="bodyRow mt-3 d-flex" *ngIf="shareDashboard">
        <cxone-radio
            type="radio"
            labelText="{{cvLocalizationService.getCachedText('Dashboard_Access', 'All_Employees', 'All Employees')}}"
            [(ngModel)]="selection"
            [value]="allEmployees"
            name="selection">
        </cxone-radio>
        <cxone-radio
            class="ml-4"
            type="radio"
            labelText="{{cvLocalizationService.getCachedText('Dashboard_Access', 'Custom', 'Custom')}}"
            [(ngModel)]="selection"
            [value]="custom"
            name="selection">
        </cxone-radio>
    </div>

    <div [hidden]="selection !== custom" class="bodyRow mt-3">

        <cxone-tabs>
            <!-- Teams Tab -->
            <cxone-tab [title]="teamsLocal + '(' + selectedTeamsList.size + ')'" #teamsTab>
                <div class="container">
                    <div class="row mb-2">
                        <cxone-multiselect-dropdown
                            *ngIf="initialized && isTeamsLoaded && teamsTab.isActive === true"
                            class="list-dropdown ml-4"
                            id="share-modal-teams"
                            [(ngModel)]="checkedTeams"
                            placeholder="{{cvLocalizationService.getCachedText('Dashboard_Access', 'Select_Teams', 'Select teams')}}"
                            [options]="teams"
                            [label]="'GroupName'"
                            [primaryKey]="'GroupID'"
                            [search]="true"
                            (dropdownClosed)="checkSelectedTeamsList()"
                            [maxItemsToDisplay]="1000">
                        </cxone-multiselect-dropdown>
                        <button (click)="removeTeamPermissions()" class="btn btn-text ml-auto mr-4" [disabled]="selectedTeamsList.size === 0" cvLocalizedText langSection="Dashboard_Access" langKey="Remove">Remove All</button>
                    </div>
                    <div class="row w-100 mx-auto search-box live-search" [hidden]="selectedTeamsList.size === 0" style="border-radius: 0px;">
                        <!-- Search -->
                        <input type="search" class="form-control"
                            autocomplete="off"
                            [(ngModel)]="teamFilterValue"
                            (ngModelChangeDebounced)="applyTeamFilter()"
                            [ngModelChangeDebounceTime]="500"
                            ng-trim="true"
                            cvLocalizedPlaceholder
                            [langSection]="'Dashboard_Access'"
                            [langKey]="'Search_Team'"
                        />
                        <span class="clear-input" role="button" tabindex="0"
                            [hidden]="filterValue.length === 0"
                            (click)="clearTeamFilter()">
                        </span>
                    </div>
                    <div class="row">
                        <!-- Teams AG Grid -->
                        <ag-grid-angular 
                            #dashboardAccessTeamGrid
                            *ngIf="teamGridOptions !== null && teamsTab.isActive && selection === custom" 
                            class="ag-theme-balham flex-fill inner col" 
                            [ngClass]="selectedTeams.length === 0 ? 'ag-grid-no-search' : 'ag-grid-search'"
                            [gridOptions]="teamGridOptions"
                            [rowHeight]="44">
                        </ag-grid-angular>
                    </div>
                </div>
            </cxone-tab>
            <!-- Employees Tab -->
            <cxone-tab [title]="employeesLocal + '(' + selectedEmployeesList.size + ')'" #employeesTab>
                <div class="container">
                    <div class="row mb-2">
                        <cxone-multiselect-dropdown
                            *ngIf="initialized && isEmpsLoaded && employeesTab.isActive === true"
                            class="list-dropdown ml-4"
                            id="share-modal-employees"
                            [(ngModel)]="checkedEmployees"
                            placeholder="{{cvLocalizationService.getCachedText('Dashboard_Access', 'Select_Employees', 'Select employees')}}"
                            [options]="employees"
                            [label]="'FullName'"
                            [primaryKey]="'LoginID'"
                            [search]="true"
                            sortKey="FullName"
                            (dropdownClosed)="checkSelectedEmpsList()"
                            [maxItemsToDisplay]="1000">
                        </cxone-multiselect-dropdown>
                        <button (click)="removeEmpPermissions()" class="btn btn-text ml-auto mr-4" [disabled]="selectedEmployeesList.size === 0" cvLocalizedText langSection="Dashboard_Access" langKey="Remove">Remove All</button>
                    </div>
                    <div class="row w-100 mx-auto search-box live-search" [hidden]="selectedEmployeesList.size === 0" style="border-radius: 0px;">
                        <!-- Search -->
                        <input type="search" class="form-control"
                            autocomplete="off"
                            [(ngModel)]="employeeFilterValue"
                            (ngModelChangeDebounced)="applyEmployeeFilter()"
                            [ngModelChangeDebounceTime]="500"
                            ng-trim="true"
                            cvLocalizedPlaceholder
                            [langSection]="'Dashboard_Access'"
                            [langKey]="'Search_Employee'"
                        />
                        <span class="clear-input" role="button" tabindex="0"
                            [hidden]="filterValue.length === 0"
                            (click)="clearEmployeeFilter()">
                        </span>
                    </div>
                    <div class="row">
                        <!-- Employees AG Grid -->
                        <ag-grid-angular 
                            #dashboardAccessEmployeeGrid
                            *ngIf="employeeGridOptions !== null && employeesTab.isActive && selection === custom" 
                            class="ag-theme-balham flex-fill inner col" 
                            [ngClass]="selectedEmployees.length === 0 ? 'ag-grid-no-search' : 'ag-grid-search'"
                            [gridOptions]="employeeGridOptions"
                            [rowHeight]="44">
                        </ag-grid-angular>
                    </div>
                </div>
            </cxone-tab>
        </cxone-tabs>
    </div>
</div>

<!-- Footer -->
<div class="modal-footer">
    <button 
        type="button" 
        class="btn btn-secondary modal-footer-btn" 
        [disabled]="isSaving" 
        cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'"
        (click)="onCancelClicked()">Cancel</button>
    <button 
        type="button" 
        class="btn btn-primary cxone-btn modal-footer-btn" 
        [disabled]="(!shareDashboard && !hasCurrentShares && !isPublic) || 
        (selection === custom && numberOfChanges === 0) ||
        (shareDashboard && selection === allEmployees && isPublic) ||
        isSaving" 
        cvLocalizedText [langSection]="'Common'" [langKey]="'Save_Button'"
        (click)="onSaveClicked()">Save</button>
</div>
